let store = require("./store");

let actions = {
  login: function (email, password, accountType = "BRC2") {
    let url = "/users/login/email";

    return mc.ajax.post(url, { email, password, accountType }).then(function (response) {
      return {
        type: "login",
        user: mc.ajax.parse(response)
      };
    }).catch(function (err) {
      return {
        type: "login",
        user: null
      };
    });
  },

  logout: function (isLoggedOut) {
    let url = "/users/logout";

    if (isLoggedOut) {
      return Promise.resolve({
        type: "logout"
      });
    }

    return mc.ajax.post(url).then(function () {
      return {
        type: "logout"
      };
    }).catch(function (err) {
      return {
        type: "logout"
      };
    });
  },

  requestPassword: function (email) {
    let url = "/users/resets";

    return mc.ajax.post(url, { email, accountType: "BRC2" }).then(function () {
      return {
        type: "requestPassword",
        email
      };
    });
  },

  savePassword: function (userId, resetId, password) {
    let url = `/users/${userId}/resets/${resetId}`;

    return mc.ajax.put(url, { password }).then(function (response) {
      return {
        type: "savePassword",
        password,
        errors: []
      };
    }).catch(function (err) {
      return {
        type: "savePassword",
        password,
        errors: [tx(err.message)]
      };
    });
  },

  acceptTerms: function (user) {
    user.legaleseVersionAccepted = user.legaleseVersionRequired;

    return actions.saveUser(user, "UPDATE");
  },

  loadUsers: function (accountId) {
    let url = `/accounts/${accountId}/users`;

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadUsers",
        users: mc.ajax.parse(response).items
      };
    });
  },

  saveUser: function (user, method) {
    let request;

    switch (method) {
      case "CREATE":
        request = mc.ajax.post("/users/register/email", { ...user, user }).then(function (response) {
          user.id = mc.ajax.parse(response).id;
          return response;
        });
        break;
      case "UPDATE":
        request = mc.ajax.put(`/users/${user.id}`, user);
        break;
      case "DELETE":
        request = mc.ajax.del(`/accounts/${user.accountId}/users/${user.id}`);
        break;
    }

    return request.then(function (response) {
      return {
        type: "saveUser",
        user,
        errors: []
      };
    }).catch(function (err) {
      return {
        type: "saveUser",
        user,
        errors: [tx(err.message)]
      };
    });
  },

  setPref: function (name, value) {
    return {
      type: "setPref",
      name,
      value
    };
  },

  setPrefs: function (prefs) {
    return {
      type: "setPrefs",
      prefs
    };
  },

  loadStudies: function (accountId) {
    let url = `/accounts/${accountId}/studies`;

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadStudies",
        studies: mc.ajax.parse(response).sort(function (a, b) {
          return a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1;
        })
      };
    });
  },

  loadStudy: function (studyId) {
    let url = `/studies/${studyId}`;

    return mc.ajax.get(url).then(function (response) {
      let study = mc.ajax.parse(response);

      return {
        type: "loadStudy",
        study
      };
    });
  },

  loadStudyStats: function (accountId) {
    var url = `/accounts/${accountId}/study_stats`;

    return mc.ajax.get(url).then(function (response) {
      var stats = mc.ajax.parse(response).items;

      return {
        type: "loadStudyStats",
        accountId,
        stats: mc.utils.hash(stats, "studyId")
      };
    });
  },

  saveStudy: function (study, method) {
    let request;
    let data = mc.utils.prune(study, [
      "displayName",
      "title",
      "description",
      "isArchived",
      "lifecycleState",
      "srcStudyId",
      "tags",
      "subjectMetadataFields",
      "isWebhookEnabled",
      "webhookUrl"
    ]);

    switch (method) {
      case "CREATE":
        request = mc.ajax.post(`/accounts/${study.accountId}/studies`, data).then(function (response) {
          study.id = mc.ajax.parse(response).id;
          return response;
        });
        break;
      case "UPDATE":
      case "DELETE":
        request = mc.ajax.put(`/accounts/${study.accountId}/studies/${study.id}`, data);
        break;
    }

    return request.then(function (response) {
      return {
        type: "saveStudy",
        study,
        errors: []
      };
    }).catch(function (err) {
      return {
        type: "saveStudy",
        study,
        errors: [tx(err.message)]
      };
    });
  },

  copyStudy: function (study) {
    study.srcStudyId = study.id;
    study.id = null;

    return actions.saveStudy(study, "CREATE");
  },

  loadSubject: function (studyId, subjectId) {
    let url = `/studies/${studyId}/subjects/${subjectId}`;

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadSubject",
        subject: mc.ajax.parse(response)
      };
    });
  },

  saveSubject: function (subject, method) {
    let request;
    let data = mc.utils.prune(subject, [
      "displayName",
      "timezone",
      "gender",
      "age",
      "weight",
      "height",
      "metadataFields"
    ]);

    switch (method) {
      case "CREATE":
        request = mc.ajax.post(`/studies/${subject.studyId}/subjects`, data).then(function (response) {
          subject.id = mc.ajax.parse(response).id;
          return response;
        });
        break;
      case "UPDATE":
        request = mc.ajax.put(`/studies/${subject.studyId}/subjects/${subject.id}`, data);
        break;
      case "DELETE":
        request = mc.ajax.del(`/studies/${subject.studyId}/subjects/${subject.id}`);
        break;
    }

    return request.then(function (response) {
      return {
        type: "saveSubject",
        subject,
        errors: []
      };
    }).catch(function (err) {
      return {
        type: "saveSubject",
        subject,
        errors: [tx(err.message)]
      };
    });
  },

  createSubjectToken: function (studyId, subjectId) {
    let url = `/studies/${studyId}/subjects/${subjectId}/tokens`;

    return mc.ajax.post(url).then(function (response) {
      return {
        type: "createSubjectToken",
        token: mc.ajax.parse(response).token
      };
    }).catch(function (err) {
      throw err;
    });
  },

  loadAnnotations: function (studyId, subjectId, startTs, stopTs) {
    let url = `/studies/${studyId}/subjects/${subjectId}/annotations?type=activity&type=diary&type=recording&type=subject`;

    if (startTs) {
      url += "&from=" + startTs;

      if (stopTs) {
        url += "&to=" + stopTs;
      }
    }

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadAnnotations",
        subjectId,
        annotations: mc.ajax.parse(response).items.sort(function (a, b) {
          return a.startTs - b.startTs;
        })
      };
    });
  },

  saveAnnotation: function (annotation, method) {
    let request;

    switch (method) {
      case "CREATE":
        request = mc.ajax.post(`/studies/${annotation.studyId}/subjects/${annotation.subjectId}/annotations`, annotation).then(function (response) {
          annotation.id = mc.ajax.parse(response).id;
          return response;
        });
        break;
      case "UPDATE":
        request = mc.ajax.put(`/studies/${annotation.studyId}/subjects/${annotation.subjectId}/annotations/${annotation.id}`, annotation);
        break;
      case "DELETE":
        request = mc.ajax.del(`/studies/${annotation.studyId}/subjects/${annotation.subjectId}/annotations/${annotation.id}`);
        break;
    }

    // TODO catch
    return request.then(function (response) {
      return {
        type: "saveAnnotation",
        annotation,
        errors: []
      };
    });
  },

  loadEquipment: function (studyId, subjectId) {
    let url = `/studies/${studyId}/subjects/${subjectId}/equipment`;

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadEquipment",
        subjectId,
        equipment: mc.ajax.parse(response).items.sort(function (a, b) {
          return a.type > b.type ? 1 : -1;
        })
      };
    });
  },

  loadEquipmentLog: function (accountId, serialNumber) {
    let url = `/accounts/${accountId}/equipment/${serialNumber}/history`;

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadEquipmentLog",
        serialNumber,
        equipmentLog: mc.ajax.parse(response).items
      };
    });
  },

  saveActivity: function (activity, method) {
    let request;

    switch (method) {
      case "CREATE":
        request = mc.ajax.post(`/studies/${activity.studyId}/activities`, activity).then(function (response) {
          activity.id = mc.ajax.parse(response).id;
          return response;
        });
        break;
      case "UPDATE":
        request = mc.ajax.put(`/studies/${activity.studyId}/activities/${activity.id}`, activity);
        break;
      case "DELETE":
        request = mc.ajax.del(`/studies/${activity.studyId}/activities/${activity.id}`);
        break;
    }

    return request.then(function (response) {
      return {
        type: "saveActivity",
        activity,
        errors: []
      };
    }).catch(function (err) {
      return {
        type: "saveActivity",
        activity,
        errors: [tx(err.message)]
      };
    });
  },

  copyActivity: function (activity) {
    activity.order = ~~(Date.now() / 1000) - 1420088400;

    return actions.saveActivity(activity, "CREATE");
  },

  // TODO order should be saved outside of entity
  saveActivitySequence: function (activities) {
    let requests = activities.map(function (activity, i) {
      let url = `/studies/${activity.studyId}/activities/${activity.id}`;

      activity.order = i;

      return mc.ajax.put(url, activity);
    });

    return Promise.all(requests).then(function () {
      return {
        type: "saveActivitySequence",
        activities
      };
    });
  },

  saveDiary: function (diary, method) {
    let request;

    switch (method) {
      case "CREATE":
        request = mc.ajax.post(`/studies/${diary.studyId}/diaries`, diary).then(function (response) {
          diary.id = mc.ajax.parse(response).id;
          return response;
        });
        break;
      case "UPDATE":
        request = mc.ajax.put(`/studies/${diary.studyId}/diaries/${diary.id}`, diary);
        break;
      case "DELETE":
        request = mc.ajax.del(`/studies/${diary.studyId}/diaries/${diary.id}`);
        break;
    }

    return request.then(function (response) {
      return {
        type: "saveDiary",
        diary,
        errors: []
      };
    }).catch(function (err) {
      return {
        type: "saveDiary",
        diary,
        errors: [tx(err.message)]
      };
    });
  },

  copyDiary: function (diary) {
    diary.order = ~~(Date.now() / 1000) - 1420088400;

    return actions.saveDiary(diary, "CREATE");
  },

  // TODO order should be saved outside of entity
  saveDiarySequence: function (diaries) {
    let requests = diaries.map(function (diary, i) {
      let url = `/studies/${diary.studyId}/diaries/${diary.id}`;

      diary.order = i;

      return mc.ajax.put(url, diary);
    });

    return Promise.all(requests).then(function () {
      return {
        type: "saveDiarySequence",
        diaries
      };
    });
  },

  saveDeviceConfig: function (deviceConfig, method) {
    let request;

    switch (method) {
      case "CREATE":
        request = mc.ajax.post(`/studies/${deviceConfig.studyId}/device_configs`, deviceConfig).then(function (response) {
          deviceConfig.id = mc.ajax.parse(response).id;
          return response;
        });
        break;
      case "UPDATE":
        request = mc.ajax.put(`/studies/${deviceConfig.studyId}/device_configs/${deviceConfig.id}`, deviceConfig);
        break;
      case "DELETE":
        request = mc.ajax.del(`/studies/${deviceConfig.studyId}/device_configs/${deviceConfig.id}`);
        break;
    }

    return request.then(function (response) {
      return {
        type: "saveDeviceConfig",
        deviceConfig,
        errors: []
      };
    }).catch(function (err) {
      return {
        type: "saveDeviceConfig",
        deviceConfig,
        errors: [tx(err.message)]
      };
    });
  },

  saveProgram: function (program, studyId, method) {
    let request;

    switch (method) {
      case "CREATE":
        request = mc.ajax.post(`/studies/${studyId}/programs`, program).then(function (response) {
          program.id = mc.ajax.parse(response).id;
          return response;
        });
        break;
      case "UPDATE":
        request = mc.ajax.put(`/studies/${studyId}/programs/${program.id}`, program);
        break;
    }

    return request.then(function (response) {
      return {
        type: "saveProgram",
        program,
        errors: []
      };
    }).catch(function (err) {
      return {
        type: "saveProgram",
        program,
        errors: [tx(err.message)]
      };
    });
  },

  loadUnreadMessages: function (accountId) {
    let url = `/accounts/${accountId}/messages`;

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadUnreadMessages",
        messages: mc.ajax.parse(response).items
      };
    });
  },

  loadMessages: function (studyId, subjectId) {
    let url = `/studies/${studyId}/subjects/${subjectId}/messages`;

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadMessages",
        subjectId,
        messages: mc.ajax.parse(response).items
      };
    });
  },

  readMessages: function (studyId, subjectId, messageIds) {
    let url = `/studies/${studyId}/subjects/${subjectId}/messages`;

    let data = {
      states: messageIds.map(function (messageId) {
        return { messageId, isRead: true };
      })
    };

    return mc.ajax.put(url, data).then(function (response) {
      return {
        type: "readMessages",
        studyId,
        subjectId,
        messageIds
      };
    });
  },

  postMessage: function (studyId, subjectId, body) {
    let url = `/studies/${studyId}/subjects/${subjectId}/messages`;

    let data = new FormData();
    data.append("body", body);

    return mc.ajax.post(url, data).then(function (response) {
      return {
        type: "postMessage",
        studyId,
        subjectId,
        errors: []
      };
    }).catch(function (err) {
      return {
        type: "postMessage",
        studyId,
        subjectId,
        errors: [tx(err.message)]
      };
    });
  },

  addPipeline: function (studyId, libraryConfigId) {
    let url = `/studies/${studyId}/pipelines`;

    return mc.ajax.post(url, { libraryConfigId }).then(function (response) {
      return {
        type: "addPipeline"
      };
    });
  },

  removePipeline: function (studyId, pipelineId) {
    let url = `/studies/${studyId}/pipelines/${pipelineId}`;

    return mc.ajax.del(url, { pipelineId }).then(function (response) {
      return {
        type: "removePipeline"
      };
    });
  },

  requestArchive: function (studyId) {
    let url = `/archives/${studyId}/archive`;

    return mc.ajax.post(url).then(function (response) {
      return {
        type: "requestArchive"
      };
    });
  },

  downloadArchive: function (href) {
    let url = href.replace(/^\/v\d+/, "");

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "downloadArchive",
        href: mc.ajax.parse(response).href
      };
    });
  },

  loadMetrics: function (studyId, subjectId, startTs, stopTs) {
    let url = `/studies/${studyId}/subjects/${subjectId}/pipelines/metrics`;

    if (startTs) {
      url += `?from=${startTs}&to=${stopTs}`;
    }

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadMetrics",
        subjectId,
        metrics: mc.ajax.parse(response).items
      };
    });
  },

  loadChannels: function (studyId, subjectId, startTs, stopTs, interval = 60000) {
    let libConfigId = "fdd051b8-d753-11e6-ab51-34363bc84032";
    let masterId = "4e8a80fd-4778-11e6-a313-34363bc3dbe2";
    let url = `/studies/${studyId}/subjects/${subjectId}/pipelines/${libConfigId}/channels?masterId=${masterId}&from=${startTs}&to=${stopTs}&interval=${interval}`;

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadChannels",
        channels: mc.ajax.parse(response).channels
      };
    });
  },

  loadSubjectComplianceStats: function (studyId, subjectId) {
    let url = `/studies/${studyId}/subjects/${subjectId}/program_stats`;

    return mc.ajax.get(url).then(function (response) {
      return {
        type: "loadSubjectComplianceStats",
        subjectId,
        stats: mc.ajax.parse(response).items
      };
    });
  },

  loadStudyComplianceStats: function (studyId) {
    let url = `/studies/${studyId}/program_stats`;

    return mc.ajax.get(url).then(function (response) {
      let stats = mc.ajax.parse(response).items;

      return {
        type: "loadStudyComplianceStats",
        studyId,
        stats: mc.utils.hash(stats, "subjectId")
      };
    });
  },

  loadRecordingStats: function (studyId) {
    let url = `/studies/${studyId}/recording_stats`;

    return mc.ajax.get(url).then(function (response) {
      let stats = mc.ajax.parse(response).items;

      return {
        type: "loadRecordingStats",
        studyId,
        stats: mc.utils.hash(stats, "subjectId")
      };
    });
  },

  loadFaultStats: function (studyId) {
    let url = `/studies/${studyId}/fault_stats`;

    return mc.ajax.get(url).then(function (response) {
      let stats = mc.ajax.parse(response).items;

      return {
        type: "loadFaultStats",
        studyId,
        stats: mc.utils.hash(stats, "subjectId")
      };
    });
  }
};

module.exports = mc.state.bindActions(actions, store);
